export default {
      id: "cook-usage",
      viewBox: "0 0 37 48",
      url: __webpack_public_path__ + "img/icons.svg#cook",
      toString: function () {
        return this.url;
      }
    }